export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--F.6b768323.png";